import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-4xl mx-auto relative rounded-2xl overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Dramatic%20sports%20stadium%20atmosphere%20with%20golden%20floodlights%2C%20warm%20cinematic%20lighting%2C%20empty%20arena%20with%20epic%20scale%2C%20professional%20sports%20venue%2C%20dark%20moody%20background%20with%20warm%20highlights%2C%20no%20people%20or%20text&width=1400&height=600&seq=cta-bb-sports&orientation=landscape')`,
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-900/85 via-background-900/75 to-background-900/85"></div>

        <div className="relative z-10 py-14 md:py-20 px-6 md:px-12 text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
            加入BB体育大家庭
          </h2>
          <p className="text-background-200/90 text-sm md:text-base max-w-xl mx-auto mb-8">
            注册即享专属福利，获取最新赛事资讯、专业分析和独家优惠。BB体育，您的专业体育赛事伙伴。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即注册
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-lg bg-background-50/10 text-background-50 font-medium text-base border border-background-50/30 hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}